import React, { useEffect, useState } from "react";
import { useLoading } from "../../common/LoadingContext";
import { useNotificationContext } from "../../common/NotificationContext";
import { Routes, Route } from "react-router-dom";
import SpareSearchListing from "./SpareSearchListing";
import {
  SpareListingService,
  StatusListingService,
  PartTypeListingService,
  SpareListingOnSearchService,
  ActionsListingService,
  onAddSpareService,
  onEditSpareService,
  fetchSpareDetailsByIdService,
  SpareChangeStatusService,
  DownloadSparesService,
  VendorListingService,
  deleteSpareService
} from "../../services/SpareSearchService";
import {
  setVendorSearch_, setActionSearch_, setBrandSearch_, setBrickSearch_, setPartTypeSearch_, setActiveSearch_, setSearchModelNameValue_, setSearchArticleCodeValue_, setSearchDescriptionValue_
} from "../../reducer/action";
import {
  brandListingOnSelectedBrickService,
  brickListingOnSelectedBrandService,
} from "../../services/ModelViewService";
import SpareView from "./SpareView";
import useGlobalState from "../../Context";
import { useForm } from "react-hook-form";
import ModelsDetail from "./ModelDetails";
import SparePhotos from "../ModelSearchNew/SparePhoto";
import SpareDetails from "../ModelSearchNew/SpareDetails";
import VendorsDetailBySpareId from "./VendorDetail";
import AddEditSpare from "./AddEditSpare"



const SpareSearch = () => {
  const { showNotification } = useNotificationContext();
  const [setTableLoader] = useState(false);
  const { setLoading } = useLoading();
  const [spareRecords, setSpareRecords] = useState([]);
  const [totalElements, setTotalElements] = useState(0);
  const [statusList, setStatusList] = useState([]);
  const [partTypeList, setPartTypeList] = useState([]);
  const [brandListOnBrickId, setBrandListOnBrickId] = useState([]);
  const [brickListOnBrandId, setBrickListOnBrandId] = useState([]);
  const [actionList, setActionList] = useState([]);
  const [vendorList, setVendorList] = useState([]);
  const [noRecord, setNoRecord] = useState(false);
  const [formData, setFormData] = useState({});
  const [searchedRows, setSearchedRows] = useState(spareRecords);
  const [nameSearch, setNameSearch] = useState("");
  const [vendorSearch, setVendorSearch] = useState(null);
  const [searchModelNameValue, setSearchModelNameValue] = useState(null);
  const [brandSearch, setBrandSearch] = useState(null);
  const [brickSearch, setBrickSearch] = useState(null);
  const [partTypeSearch, setPartTypeSearch] = useState(null);
  const [statusSearch, setStatuSearch] = useState(null);
  const [actionSearch, setActionSearch] = useState(null);
  const [activeSearch, setActiveSearch] = useState(null);
  const [searchArticleCodeValue, setSearchArticleCodeValue] = useState("");
  const [searchDescriptionValue, setSearchDescriptionValue] = useState("");
  const [disableSearchButton, setDisableSearchButton] = useState(true);
  const [disableFilterButton, setdisableFilterButton] = useState(true);
  const [disableDownloadButton, setDisableDownloadButton] = useState(true);
  const [value, setValue] = useState('');
  const [page, setPage] = useState(0);
  const [maxPage, setMaxPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [selected, setSelected] = useState([]);
  const [disableUpdateButton, setDisbaleUpdateButton] = useState(true);
  const [{ auth }, dispatch] = useGlobalState();
  const loginUserType = auth.ldapParam.userType;
  const loggedInUserInfo = auth.ldapParam.userId;

  const formOption = {
    // resolver: yupResolver(ADD_SPARE_VALIDATIONS),
    defaultValues: { ...formData },
  };

  const { reset } = useForm(formOption);

  useEffect(() => {
    fetchSpareDetails("code", false);
    dispatch(setVendorSearch_(null));
    dispatch(setActionSearch_(null));
    dispatch(setBrandSearch_(null));
    dispatch(setBrickSearch_(null));
    dispatch(setPartTypeSearch_(null));
    dispatch(setActiveSearch_(null));
    dispatch(setSearchModelNameValue_(null));
    dispatch(setSearchArticleCodeValue_(null));
    dispatch(setSearchDescriptionValue_(null));
    fetchVendorList();
    fetchActionsList();
    fetchBrandListOnSelectedBrick();
    fetchBrickListOnSelectedBrand();
    if (localStorage.getItem('partTypeListItem') == '' || localStorage.getItem('partTypeListItem') == null || localStorage.getItem('partTypeListItem') == undefined) {
      fetchPartTypeList();
    }
  }, []);

  useEffect(() => {
    const selectedRows =
      spareRecords &&
      spareRecords.filter(
        (row) =>
          row.code && row.code.toUpperCase().includes(nameSearch.toUpperCase())
      );
    setSearchedRows(selectedRows);
  }, [nameSearch, spareRecords]);

  const fetchSpareDetails = async (sortBy, isAsc, vendorSearch, actionSearch, brandSearch, brickSearch, partTypeSearch, activeSearch, searchModelNameValue, searchArticleCodeValue, searchDescriptionValue, paginationValues) => {
    try {
      setLoading(true);

      const spareRequestObj = {
        spareSearchParam: {
          brandId: brandSearch ? brandSearch : null,
          brickId: brickSearch ? brickSearch : null,
          modelName: searchModelNameValue ? searchModelNameValue.trim() : null,
          partTypeId: partTypeSearch ? partTypeSearch : null,
          defActionId: actionSearch ? actionSearch : null,
          vendorId: vendorSearch ? vendorSearch : null,
          spareIds: null,
          active: activeSearch == null ? loginUserType === "Main Admin" ? 2 : 0 : activeSearch,
          articleCode: searchArticleCodeValue ? searchArticleCodeValue.trim() : null,
          description: searchDescriptionValue ? searchDescriptionValue.trim() : null,
        },
        sparePage: {
          pageNumber: paginationValues?.pageNumber ?? 0,
          pageSize: paginationValues?.pageSize ?? 10,
          sortDirection: isAsc ? "DESC" : "ASC",
          sortBy: sortBy,
        },
      };
      const spareListingResponse = await SpareListingService(spareRequestObj);
      if (spareListingResponse.statusCode === 6) {
        if (spareListingResponse.data.content?.length === 0) {
          setNoRecord(true);
        } else {
          setNoRecord(false);
        }
        setSpareRecords(spareListingResponse.data.content);
        setTotalElements(spareListingResponse.data.totalElements);

      } else {
        showNotification("Error", spareListingResponse.message, "error");
      }
    } catch (err) {
      showNotification("Error", err.message ?? "Failed to fetch user details");
    } finally {
      setLoading(false);
    }
  };

  const handleDeleteSpare = async (row) => {
    try {
      setLoading(true);
      const payload = {
        spareId: row.spareId,
        userId: loggedInUserInfo
      };
      const res = await deleteSpareService(payload);

      if (res?.statusCode === 6) {
        showNotification(
          "Success",
          res?.message ?? "Spare deleted successfully",
          "success"
        );
        await onSearchSpareList();
      } else {
        showNotification(
          "Error",
          res?.message ?? "Failed to delete spare",
          "error"
        );
      }
    } catch (err) {
      showNotification(
        "Error",
        err?.message ?? "Failed to delete spare",
        "error"
      );
    } finally {
      setLoading(false);
    }
  };

  const handleTableChanges = async (
    paginationValues,
    isUpdate,
    sortValue,
    orderBy,
    vendorSearch, actionSearch, brandSearch, brickSearch, partTypeSearch, activeSearch, searchModelNameValue, searchArticleCodeValue, searchDescriptionValue
  ) => {
    try {
      setLoading(true);
      const spareRequestObj = {
        spareSearchParam: {
          brandId: brandSearch ? brandSearch : null,
          brickId: brickSearch ? brickSearch : null,
          modelName: searchModelNameValue ? searchModelNameValue.trim() : null,
          partTypeId: partTypeSearch ? partTypeSearch : null,
          defActionId: actionSearch ? actionSearch : null,
          vendorId: vendorSearch ? vendorSearch : null,
          spareIds: null,
          active: activeSearch == null ? loginUserType === "Main Admin" ? 2 : 0 : activeSearch,
          articleCode: searchArticleCodeValue ? searchArticleCodeValue.trim() : null,
          description: searchDescriptionValue ? searchDescriptionValue.trim() : null,
        },
        sparePage: {
          pageNumber: paginationValues?.pageNumber ?? 0,
          pageSize: paginationValues?.pageSize ?? 10,
          sortDirection: sortValue === null ? "DESC" : sortValue,
          sortBy: orderBy,
        },
      };

      const response = await SpareListingService(spareRequestObj);

      if (response.statusCode == "6") {
        if (isUpdate) {
          setSpareRecords([...spareRecords, ...response.data.content]);
        } else {
          setSpareRecords(response.data.content);
        }
      } else {
        showNotification("Error", response.message, "error");
      }
    } catch (e) {
      showNotification("Error", "Failed to fetch site filter search data");
    } finally {
      setLoading(false);

    }
  };

  const onClearClick = async (paginationObject) => {

    setSearchModelNameValue("");
    setBrandSearch(null);
    setBrickSearch(null);
    setPartTypeSearch(null);
    setStatuSearch(null);
    setActionSearch(null);
    setVendorSearch(null);
    setActiveSearch(null);
    setSearchArticleCodeValue("");
    setSearchDescriptionValue("");
    setDisableSearchButton(true);
    setDisableDownloadButton(true);
    setdisableFilterButton(true);
    await fetchBrickListOnSelectedBrand();
    await fetchBrandListOnSelectedBrick();

    const paginationData = {
      pageNumber: paginationObject?.pageNumber ?? 0,
      pageSize: paginationObject?.pageSize ?? 10,
    };

    await fetchSpareDetails("code", false, null, null, null, null, null, null, null, null, null, paginationData);

    // }
  };

  const fetchStatusList = async () => {
    try {
      const statusListingResponse = await StatusListingService();
      if (statusListingResponse.statusCode == "6") {
        setStatusList(statusListingResponse?.data);
      } else {
        showNotification("Error", statusListingResponse.message, "error");
      }
    } catch (err) {
      console.log("error", err);
    } finally {
      // setLoading(false);
    }
  };

  const fetchPartTypeList = async () => {
    try {
      const partTypeListingResponse = await PartTypeListingService();

      if (partTypeListingResponse.statusCode == "6") {
        localStorage.setItem('partTypeListItem', JSON.stringify(partTypeListingResponse.data))
        setPartTypeList(partTypeListingResponse.data);
      } else {
        showNotification("Error", partTypeListingResponse.message, "error");
      }
    } catch (err) {
      console.log("error", err);
    } finally {
      // setLoading(false);
    }
  };

  const fetchActionsList = async () => {
    try {
      const actionsListingResponse = await ActionsListingService();
      if (actionsListingResponse.statusCode == "6") {
        setActionList(actionsListingResponse.data);
      } else {
        showNotification("Error", actionsListingResponse.message, "error");
      }
    } catch (err) {
      console.log("error", err);
    } finally {
      // setLoading(false);
    }
  };

  const fetchBrandListOnSelectedBrick = async (id) => {
    try {
      const brandListingResponse = await brandListingOnSelectedBrickService(id);
      if (brandListingResponse.statusCode == "6") {
        setBrandListOnBrickId(brandListingResponse.data);
      } else {
        showNotification("Error", brandListingResponse.message, "error");
      }
    } catch (err) {
      console.log("error", err);
    } finally {
      // setLoading(false);
    }
  };

  const fetchBrickListOnSelectedBrand = async (id) => {
    try {
      const brickListingResponse = await brickListingOnSelectedBrandService(id);
      if (brickListingResponse.statusCode == "6") {
        setBrickListOnBrandId(brickListingResponse.data);
      } else {
        showNotification("Error", brickListingResponse.message, "error");
      }
    } catch (err) {
      console.log("error", err);
    } finally {
      // setLoading(false);
    }
  };

  const fetchVendorList = async () => {
    try {
      const response = await VendorListingService();
      if (response.statusCode == "6") {
        setVendorList(response.data);
      } else {
        showNotification("Error", response.message, "error");
      }
    } catch (err) {
      console.log("error", err);
    } finally {
      // setLoading(false);
    }
  };

  const onSearchSpareList = async (values) => {
    try {
      setLoading(true);
      const spareRequestObj = {
        brandId: values?.brandId ?? null,
        brickId: values?.brickId ?? null,
        modelName: values?.modelName ?? null,
        status: values?.status ?? null,
        partTypeId: values?.partTypeId ?? null,
        pageNumber: values?.pageNumber ?? 0,
        pageSize: values?.pageSize ?? 10,
        sortDirection: values?.sortDirection,
        sortBy: values?.sortBy,
        articleCode: values?.articleCode,
        description: values?.description,
        defActionId: values?.defActionId ?? null,
        vendorId: values?.vendorId ?? null,
        spareIds: null,
        active: values?.active == null ? loginUserType === "Main Admin" ? 2 : 0 : values?.active,
      };
      const spareListingResponse = await SpareListingOnSearchService(
        spareRequestObj
      );
      if (spareListingResponse.statusCode === 6) {
        if (spareListingResponse.data.content?.length === 0) {
          setNoRecord(true);
        } else {
          setNoRecord(false);
        }
        setSpareRecords(spareListingResponse.data.content);
        setTotalElements(spareListingResponse.data.totalElements);
        return spareListingResponse.data.totalElements;
      } else {
        showNotification("Error", spareListingResponse.message, "error");
      }
    } catch (err) {
      showNotification("Error", err.message ?? "Failed to fetch user details");
    } finally {
      setLoading(false);
    }
  };

  const downloadSpareDetails = async (values) => {
    try {
      setLoading(true);
      const obj = {
        brandId: values?.brandId ?? null,
        brickId: values?.brickId ?? null,
        modelName: values.modelName,
        spareIds: null,
        partTypeId: values?.partTypeId ?? null,
        articleCode: values.articleCode,
        description: values.description,
        defActionId: values.defActionId,
        vendorId: values?.vendorId ?? null,
        active: values?.active ?? (loginUserType === "Main Admin" ? 2 : 0),
      };
      const response = await DownloadSparesService(obj);
      return response;
    } catch (err) {
      showNotification("Error", err.message ?? "Failed to fetch user details");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Routes>
        <Route
          path="/"
          element={
            <SpareSearchListing
              totalElements={totalElements}
              spareRecords={spareRecords}
              handleTableChanges={handleTableChanges}
              fetchSpareDetails={fetchSpareDetails}
              statusList={statusList}
              partTypeList={partTypeList}
              brandListOnBrickId={brandListOnBrickId}
              brickListOnBrandId={brickListOnBrandId}
              fetchBrandListOnSelectedBrick={fetchBrandListOnSelectedBrick}
              fetchBrickListOnSelectedBrand={fetchBrickListOnSelectedBrand}
              onSearchSpareList={onSearchSpareList}
              setLoading={setLoading}
              showNotification={showNotification}
              actionList={actionList}
              onAddSpareService={onAddSpareService}
              onEditSpareService={onEditSpareService}
              fetchSpareDetailsByIdService={fetchSpareDetailsByIdService}
              setSpareRecords={setSpareRecords}
              SpareChangeStatusService={SpareChangeStatusService}
              downloadSpareDetails={downloadSpareDetails}
              vendorList={vendorList}
              noRecord={noRecord}
              reset={reset}
              formData={formData}
              setFormData={setFormData}
              searchedRows={searchedRows}
              vendorSearch={vendorSearch}
              setVendorSearch={setVendorSearch}
              onClearClick={onClearClick}
              searchModelNameValue={searchModelNameValue}
              setSearchModelNameValue={setSearchModelNameValue}
              brandSearch={brandSearch}
              setBrandSearch={setBrandSearch}
              setBrickSearch={setBrickSearch}
              brickSearch={brickSearch}
              partTypeSearch={partTypeSearch}
              setPartTypeSearch={setPartTypeSearch}
              actionSearch={actionSearch}
              setActionSearch={setActionSearch}
              statusSearch={statusSearch}
              activeSearch={activeSearch}
              setActiveSearch={setActiveSearch}
              searchArticleCodeValue={searchArticleCodeValue}
              setSearchArticleCodeValue={setSearchArticleCodeValue}
              setSearchDescriptionValue={setSearchDescriptionValue}
              searchDescriptionValue={searchDescriptionValue}
              disableSearchButton={disableSearchButton}
              disableFilterButton={disableFilterButton}
              disableDownloadButton={disableDownloadButton}
              setDisableSearchButton={setDisableSearchButton}
              setdisableFilterButton={setdisableFilterButton}
              setDisableDownloadButton={setDisableDownloadButton}
              value={value}
              setValue={setValue}
              page={page}
              setPage={setPage}
              maxPage={maxPage}
              setMaxPage={setMaxPage}
              rowsPerPage={rowsPerPage}
              setRowsPerPage={setRowsPerPage}
              selected={selected}
              setSelected={setSelected}
              disableUpdateButton={disableUpdateButton}
              setDisbaleUpdateButton={setDisbaleUpdateButton}
              handleDeleteSpare={handleDeleteSpare}
            />
          }
        />
        <Route path="spare-view" element={<SpareView onClearClick={onClearClick} />}></Route>
        <Route path="models-detail" element={<ModelsDetail onClearClick={onClearClick} />}></Route>
        <Route path="spare-photos" element={<SparePhotos onClearClick={onClearClick} />}></Route>
        <Route path="spare-details" element={<SpareDetails onClearClick={onClearClick} />}></Route>
        <Route path="vendors-detail" element={<VendorsDetailBySpareId onClearClick={onClearClick} />}></Route>
        <Route path="suppliers-detail" element={<VendorsDetailBySpareId onClearClick={onClearClick} />}></Route>
        <Route path="add-spare" element={<AddEditSpare onClearClick={onClearClick} />}></Route>
        <Route path="Edit-spare" element={<AddEditSpare onClearClick={onClearClick} />}></Route>
      </Routes>
    </>
  );
};

export default SpareSearch;
